export enum ItemsGroupByType {
    Id = 'id',
    Description = 'description',
}
